'use strict';

var mapAllKeys = require('../iterable/mapAllKeys');

var deepMerge = function deepMerge(value1, value2) {
  if (value1 instanceof Object && value2 instanceof Object) {
    return mapAllKeys(value1, value2, deepMerge);
  }
  return value2 === undefined ? value1 : value2;
};

module.exports = deepMerge;


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/misc/deepMerge.js
// module id = 2192
// module chunks = 37